<ion-header no-border mode="md">
  <ion-toolbar mode="md" text-wrap>
    <div class="header-title-with-button">
     <div class="custom-title">
       {{ goalProgress?.title }}
      </div>
    <ion-button mode="ios" fill="solid" color="secondary"
      (click)="goToGoals()" *ngIf="allowComments" >
      {{ 'goalProgressInfo.goalConfiguration' | translate }}
    </ion-button>
    </div>
    <ion-buttons slot="end" >
      <ion-button mode="ios" size="small" color="secondary" (click)="dismiss()">
        <ion-icon class="bp-close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content id="modalContent" padding >

  <div id="canvasContainer" >
    <canvas
      id="myChart" width="555" style="margin-left: -5px"
      [hidden]="!goalProgress"
    ></canvas>
  </div>

  <ng-container *ngIf="allowComments" >
    <ion-card mode="ios" class="goal-achivement-details">
      <ion-card-header color="primary">
        <ion-button color="secondary" mode="ios">
          {{ 'goalProgressInfo.addComment' | translate }}
        </ion-button>
        <div class="achivement">
          {{ 'goalProgressInfo.goalAchievement' | translate }} (%) 
          <ion-item class="currentProgress" lines="none" mode="ios" color="primary">
            <ion-select 
              [(ngModel)]="currentProgress"
              (ionChange)="addNewProgress(goalProgress.id, currentProgress)" >
              <ion-select-option
                *ngFor="let num of (100 | doLoop); let index = index"
                [value]="index + 1" >
                {{ index + 1 }}%
              </ion-select-option>
            </ion-select>
          </ion-item>
        </div>
      </ion-card-header>
  
      <ion-card-content class="ion-no-padding" *ngIf="goalProgress" >
        <ion-list mode="ios" lines="full">
          <ion-item>
            <ion-textarea
              [placeholder]="'goalProgressInfo.newComment' | translate"
              [(ngModel)]="newComment"
            ></ion-textarea>
            <ion-button color="primary" mode="ios" 
              (click)="addNewComment(goalProgress.id, newComment)" >
              {{ 'goalProgressInfo.addComment' | translate }}
            </ion-button>
          </ion-item>
          <ion-item *ngFor="let comment of goalProgress.comments" >
            <ion-avatar slot="start">
              <img [src]="getImageUrl(goalProgress.userImgUrl)" default alt="">
            </ion-avatar>
            <ion-label class="ion-text-wrap">
              <h2> 
                <span class="name">{{ goalProgress.userName }}</span>
                <small>
                  <span>
                    {{ getDateDiff(comment) }} {{ 'goalProgressInfo.createdAt' | translate }}
                  </span>
                </small>
              </h2>
              <p>{{ comment.text }}</p>
              <p class="delete" (click)="confirmDeleteComment(goalProgress.id, comment.id)" >
                {{ 'generic.delete' | translate }}
              </p>
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-card-content>
    </ion-card>
  </ng-container>

</ion-content>